import { GroupedSideBar } from "./GroupedSideBar";
import { UngroupedSideBar } from "./UngroupedSideBar";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import NewsletterDrawerItem from "@/components/Newsletter/navigation/NewsletterDrawerItem";

export const MainDrawerItems = () => {
  const Settings = useSettingsContext();

  return <>
    {Settings.sidebar?.groups ? <GroupedSideBar /> : <UngroupedSideBar />}

    {Settings?.newsletter?.enabled && <NewsletterDrawerItem />}
    
  </>
}